/* eslint-disable no-unused-vars */
import axios from 'axios';
import MockApi from './MockApi';
import services from '../../fixtures/apiResponses/services.json';
import apiEndpoints from '../globals/apiEndpoints';

export default class Services {
	static fetch() {
		return axios.get(apiEndpoints.services)
		.then((response) => response.data)
		.catch((error) => {
			console.log('Error ' + error.message)
		  });
	}
}
